<template>
  <div>
    <el-dialog
      :visible.sync="visibleUpload"
      :append-to-body="true"
      show-close
      @open="open"
      @close="close"
      custom-class="downClass"
      style="border-radius: 5px;"
      class="downForm"
    >
      <div slot="title" class="header-title">
        <span class="leftIcon"></span>
        <span class="title-text">
          入孵申请
        </span>
      </div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="160px"
        :disabled="true"
        style="margin: 0;"
      >
        <el-form-item label="类型" prop="applicationType">
          <el-radio v-model="ruleForm.applicationType" :label="1">团队</el-radio>
          <el-radio v-model="ruleForm.applicationType" :label="2">企业</el-radio>
        </el-form-item>
        <template v-if="ruleForm.applicationType === 1">
          <el-form-item label="团队名称" prop="companyName">
            <el-input v-model="ruleForm.companyName" placeholder="请输入团队名称"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="法人身份证" prop="legalPersonSrc">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadURL"
                  :disabled="true"
                  name="file"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) =>
                      handlePictureCardPreview(response, file, fileList, 'legalPersonSrc')
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="ruleForm.legalPersonSrc"
                    :src="imgUrl + ruleForm.legalPersonSrc"
                    class="img_border"
                  />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    :class="{ is_border: !ruleForm.logo }"
                  ></i>
                  <span class="upload_btn" v-if="!ruleForm.legalPersonSrc">上传图片</span>
                  <span v-else class="upload_btn">更换图片</span>
                </el-upload>
                <!-- <span class="del_img" v-show="ruleForm.legalPersonSrc">
                  <i class="el-icon-error" @click="deleteImg('legalPersonSrc')"></i>
                </span> -->
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-form-item label="单位类别" prop="institutionalNature">
            <el-select v-model="ruleForm.institutionalNature">
              <el-option
                v-for="(item, index) in institutionalOption"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业名称" prop="companyName">
            <el-select
              v-model="ruleForm.companyName"
              filterable
              clearable
              remote
              :remote-method="getAllCompany"
              placeholder="请填写企业名称"
              :popper-append-to-body="false"
              @change="detailInfo"
              style="width: 100%;text-align: left;"
            >
              <el-option
                v-for="(item, index) in companys"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="orgCode">
            <el-input v-model="ruleForm.orgCode" placeholder="请输入统一社会信用代码"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="法人身份证" prop="legalPersonSrc">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadURL"
                  name="file"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) =>
                      handlePictureCardPreview(response, file, fileList, 'legalPersonSrc')
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="ruleForm.legalPersonSrc"
                    :src="imgUrl + ruleForm.legalPersonSrc"
                    class="img_border"
                  />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    :class="{ is_border: !ruleForm.logo }"
                  ></i>
                  <span class="upload_btn" v-if="!ruleForm.legalPersonSrc">上传图片</span>
                  <span v-else class="upload_btn">更换图片</span>
                </el-upload>
                <!-- <span class="del_img" v-show="ruleForm.legalPersonSrc">
                  <i class="el-icon-error" @click="deleteImg('legalPersonSrc')"></i>
                </span> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业logo" prop="logo">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadURL"
                  name="file"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) =>
                      handlePictureCardPreview(response, file, fileList, 'logo')
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="ruleForm.logo" :src="imgUrl + ruleForm.logo" class="img_border" />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    :class="{ is_border: !ruleForm.logo }"
                  ></i>
                  <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
                  <span v-else class="upload_btn">更换图片</span>
                </el-upload>
                <!-- <span class="del_img" v-show="ruleForm.logo">
                  <i class="el-icon-error" @click="deleteImg('logo')"></i>
                </span> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业执照" prop="businessLicenseSrc">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadURL"
                  name="file"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) =>
                      handlePictureCardPreview(response, file, fileList, 'businessLicenseSrc')
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="ruleForm.businessLicenseSrc"
                    :src="imgUrl + ruleForm.businessLicenseSrc"
                    class="img_border"
                  />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    :class="{ is_border: !ruleForm.businessLicenseSrc }"
                  ></i>
                  <span class="upload_btn" v-if="!ruleForm.businessLicenseSrc">上传图片</span>
                  <span v-else class="upload_btn">更换图片</span>
                </el-upload>
                <!-- <span class="del_img" v-show="ruleForm.businessLicenseSrc">
                  <i class="el-icon-error" @click="deleteImg('businessLicenseSrc')"></i>
                </span> -->
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <el-form-item label="自主知识产权" prop="independentProperty">
          <commonUpload
            @successUp="successUp"
            @removeUp="removeUp"
            :inputValue="'independentProperty'"
            :list="ruleForm.independentProperty"
          ></commonUpload>
        </el-form-item>
        <el-form-item label="入驻孵化协议" prop="incubationAgreement">
          <commonUpload
            @successUp="successUp"
            @removeUp="removeUp"
            :inputValue="'incubationAgreement'"
            :list="ruleForm.incubationAgreement"
          ></commonUpload>
        </el-form-item>
        <el-form-item label="创业人员名单表" prop="entrepreneurName">
          <commonUpload
            @successUp="successUp"
            @removeUp="removeUp"
            :inputValue="'entrepreneurName'"
            :list="ruleForm.entrepreneurName"
          ></commonUpload>
        </el-form-item>
        <el-form-item label="创客团队(企业)信息表" prop="makerTeam">
          <commonUpload
            @successUp="successUp"
            @removeUp="removeUp"
            :inputValue="'makerTeam'"
            :list="ruleForm.makerTeam"
          ></commonUpload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonUpload from '@/components/common-upload';
export default {
  name: 'uploadDialog',
  components: {
    commonUpload
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    updateItem:{
      type:Object,
      default:{}
    },
    visibleUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ruleForm: {
        applicationType: 1,
        institutionalNature: '',
        logo: '',
        companyName: '',
        orgCode: '',
        legalPersonSrc: '',
        businessLicenseSrc: '',
        independentProperty: [],
        independentPropertySrc: '',
        incubationAgreement: [],
        incubationAgreementSrc: '',
        entrepreneurName: [],
        entrepreneurNameSrc: '',
        makerTeam: [],
        makerTeamSrc: ''
      },
      rules: {
        companyName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        institutionalNature: [{ required: true, message: '请选择单位类别', trigger: 'change' }],
        orgCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        legalPersonSrc: [{ required: true, message: '请上传法人身份证', trigger: 'change' }],
        businessLicenseSrc: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
        incubationAgreement: [{ required: true, message: '请上传入驻孵化协议', trigger: 'change' }],
        entrepreneurName: [{ required: true, message: '请上传创业人员名单表', trigger: 'change' }],
        makerTeam: [{ required: true, message: '请上传创业人员名单表', trigger: 'change' }]
      },
      companys: [],
      institutionalOption: [
        {
          label: '事业单位',
          value: 1
        },
        {
          label: '国有企业',
          value: 2
        },
        {
          label: '民营企业',
          value: 3
        },
        {
          label: '其它',
          value: 4
        }
      ]
    };
  },
  watch:{
    updateItem(){
      console.log(this.updateItem);
      this.ruleForm = this.updateItem
      if (this.ruleForm.independentPropertySrc) {
        this.ruleForm.independentProperty = JSON.parse(this.ruleForm.independentPropertySrc)
      }
      if (this.ruleForm.incubationAgreementSrc) {
        this.ruleForm.incubationAgreement = JSON.parse(this.ruleForm.incubationAgreementSrc)
      }
      if (this.ruleForm.entrepreneurNameSrc) {
        this.ruleForm.entrepreneurName = JSON.parse(this.ruleForm.entrepreneurNameSrc)
      }
      if (this.ruleForm.makerTeamSrc) {
        this.ruleForm.makerTeam = JSON.parse(this.ruleForm.makerTeamSrc)
      }
    }
  },
  created() {},
  methods: {
    getList(fileList) {
      return fileList.map(el => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid
        };
      });
    },
    deleteImg(type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.ruleForm[type] = '';
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    open() {
      console.log('this.urlConfig.devUrl', this.urlConfig.devUrl);
      // this.getInvoiceDetail();
    },
    handlePictureCardPreview(response, file, fileList, type) {
      console.log(response);
      this.ruleForm[type] = response.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return type && isLt2M;
    },
    close() {
      this.$refs.ruleForm.resetFields();
      this.$emit('onClose');
    },
    getAllCompany(item) {
      this.http
        .get(`${this.urlConfig.devUrl}apij2/home-api/infra/get-tyc/getCreditCode?name=${item}`)
        .then(res => {
          if (res.code == 0) {
            const data = JSON.parse(res.data);
            this.companys = data.data.map(item => {
              return {
                label: item.companyName,
                value: item.creditCode
              };
            });
          }
        });
    },
    detailInfo(val) {
      const item = this.companys.find(detail => detail.value === val);
      this.ruleForm.companyName = item.label;
      this.ruleForm.orgCode = item.value;
    },
    //上传文件
    successUp(name, val) {
      this.fileListChange(name, val);
    },
    removeUp(name, val) {
      this.fileListChange(name, val);
    },
    fileListChange(name, val) {
      this.ruleForm[name] = this.getList(val);
      this.ruleForm[name + 'Src'] = JSON.stringify(this.ruleForm[name]);
    }
  }
};
</script>

<style scoped lang="scss">
.downForm {
  text-align: left;
  .uploadButton {
    margin-top: 23px;
    width: 155px;
    // height: 35px;
    background: #428dff;
  }
  .upload-form {
    width: 100%;
    border: none;
    /deep/ .el-upload-dragger {
      width: 518px;
    }
  }
  /deep/ .el-dialog {
    border-radius: 5px;
  }
  .leftIcon {
    position: absolute;
    left: 0;
    top: 19px;
    width: 7px;
    height: 15px;
    background: #428dff;
  }
  .downClass {
    border-radius: 5px;
  }
  .header-title {
    position: relative;
    padding: 0 0 0 20px;
    line-height: 50px;
  }
  .title-text {
    font-size: 20px;

    font-family: PingFang SC;
    color: #121212;
  }
  /deep/ .el-dialog__header {
    background: #fff !important;
    // height: 30px;
    text-align: left;
    border-radius: 5px;
  }
  /deep/.el-dialog__title {
    font-family: PingFang SC;
    color: #121212;
    // margin-left: 13px;
    // margin-top: 30px;
  }
  /deep/.el-dialog__headerbtn .el-dialog__close {
    color: #121212;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #121212;
  }
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    // border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
